// @ts-nocheck
import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';

export default function PaginaDeCargaGif() {
    return (
        <Backdrop sx={{ background: 'white', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={true} />
    );
}